<template>
    <div class="product-card flex-grow-1">
        <div class="product-image-wrapper">
            <img :src="getProductImage(product)" :alt="product.title" class="product-image" />
        </div>
        <div class="product-info p-2">
            <div class="product-price mb-0">
                {{ product.price | currency(" DA", 0, { symbolOnLeft: false }) }}
            </div>
            <h6 class="product-title mb-1">{{ product.name }}</h6>
        </div>
    </div>
</template>

<script>
import config from '@/config';

export default {
    name: 'ProductMini',
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    methods: {
        getProductImage(product) {
            if (product.pictures&&product.pictures.length>0) {
                return config.storageUrl+product.pictures[0];
            }
            return '/placeholder-image.png'; // Fallback image
        }
    }
};
</script>

<style scoped>
.product-card {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;
}

.product-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.product-image-wrapper {
    width: 100%;
    padding-top: 100%;
    /* 1:1 Aspect Ratio */
    position: relative;
    background: #f5f5f5;
}

.product-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.product-info {
    background: white;
}

.product-title {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-price {
    font-size: 16px;
    font-weight: 700;
    color: var(--color-primary);
}

/* Responsive tweaks kept minimal here; parent layout handles grid sizing */
@media (max-width: 576px) {
    .product-title {
        font-size: 9px;
    }

    .product-price {
        font-size: 9px;
    }
}
</style>
